<div class="input">
<!--
    <div class="position-wrapper">
        <img src="/content/images/calendar.png" class="input-image-calendar" (click)="picker.open()">
        <input mat-input [ngxMatDatetimePicker]="picker" class="input-component" [formControl]="dateTimeControl" (blur)="onBlur()" (click)="picker.open()">
    </div>
    <ngx-mat-datetime-picker #picker [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                             [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
                             [touchUi]="touchUi" [enableMeridian]="enableMeridian"
                             [disableMinute]="disableMinute" [hideTime]="hideTime">
    </ngx-mat-datetime-picker>
-->
  <input type="datetime-local" class="input-component" [formControl]="dateTimeControl" (blur)="onBlur()"/>
</div>
